export default {
    makeId: {
        criteriaKey: 'makeIds',
    },
    frameStyleId: {
        criteriaKey: 'frameStyleTypes',
    },
    priceRangeAll: {
        criteriaKey: 'salePriceRange',
    },
    exteriorColorId: {
        criteriaKey: 'exteriorColorIds',
    },
    yearRangeAll: {
        criteriaKey: 'yearRange',
    },
    YEAR: {
        criteriaKey: '',
    },
    modelId: {
        criteriaKey: 'modelIds',
    },
    odometerRangeAll: {
        criteriaKey: 'odometerRange',
    },
    transmissionId: {
        criteriaKey: 'transmissionTypes',
    },
    fuelId: {
        criteriaKey: 'fuelTypes',
    },
    driveTrainId: {
        criteriaKey: 'drivetrains',
    },
    TEXT_QUERY: {
        criteriaKey: 'textQuery',
    },
};
